<template>
  <div class="inputSearch">
    <div class="inputContent">
      <el-select v-model="mapType" @change='changeType' style="width: 130px;" >
        <el-option v-for="item in optionsMap" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-cascader placeholder="请选择市/区" v-model="address" :options="options" @change="addressChange"
        style="width: 140px;margin-left:10px" v-if="mapType != '3'" filterable clearable></el-cascader>
      <el-input :placeholder="placeholder" style="margin-left: 10px;width: 200px;" @input="inputChange"
        v-model="queary">
      </el-input>
      <el-button slot="append" icon="el-icon-search" @click="searchMore()">搜索</el-button>
      <!-- <div calss = 'seachbtn'>搜索</div> -->
    </div>
    <div class="searchContent" v-if="searchList.length > 0 && mapType != '3'">
      <div class="searchLi" @click="changeCenter(searchLi, searchIndex)" v-for="(searchLi, searchIndex) in searchList"
        :key="searchLi.hotPointID">
        <div>
          {{ searchLi.name }}
        </div>
        <div class="contentLi">
          {{ searchLi.address }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { area } from "../js/area";
import { mapState } from 'vuex';
import store from "../../../store"
export default {
  props: ["mapObject", "type"],
  data() {
    return {
      mapType: '1',
      optionsMap: [
        { value: '1', label: '绘制区域范围' },
        { value: '2', label: '选择地址' },
        { value: '3', label: '选择坐标' },
      ],
      address: '',
      queary: '',
      options: area,
      lastCode: '',
      searchList: [],
      placeholder: '请输入地址'
    }
  },
  computed: {
    ...mapState({
      mapData: state => state.mapData,
      mapMes: state => state.mapMes,
    })
  },
  watch: {
    mapData(newVal, oldVal) {
      this.$emit("data", newVal);
    },
    mapMes(newVal, oldVal) {
      this.$emit("zb", newVal);
    },
  },
  mounted() {
    if (this.type == '2') {
      this.optionsMap = [
        { value: '1', label: '绘制区域范围' }
      ]
    }else if (this.type == '3') {
      this.mapType = '2'
      this.optionsMap = [
        { value: '2', label: '选择地址' },
        { value: '3', label: '选择坐标' },
      ]
    }
  },
  methods: {
    //查询地址
    searchMore() {
      if (this.mapType == '3') {
        //坐标
        this.mapObject.searchZb(this.queary).then((e) => {
          if (!e) {
            this.$alert('当前坐标输入有误,请输入正确的经纬度')
          }
        })
      } else {
        this.mapObject.searchQuery(this.queary).then((e) => {
          if (e && e.length > 0) {
            this.searchList = e
            let pointList = e.map(n => {
              return { id: n.hotPointID, longitude: n.lonlat.split(',')[0], latitude: n.lonlat.split(',')[1] }
            })
            this.mapObject.addPointIcons('wjwDraw', pointList)
          } else {
            this.$alert('暂未查询到结果')
          }

        });
      }

    },
    //获取地区
    addressChange(e) {
      console.log(e)
      if(e){
        let json = area
        e.forEach((element, index) => {
          json = (json.children || json).find(n => n.value == element)
        });
        this.lastCode = json.value
        this.mapObject.selectArea(this.lastCode, json.label)
      }else{
        this.lastCode = ''
      }
      
      
    },
    changeCenter(e, index) {
      // this.mapObject.changePointStyle(index)//改变当前选中坐标样式
      this.mapObject.selectPoint([e.lonlat.split(',')[0], e.lonlat.split(',')[1]])
      this.mapObject.setCenter([e.lonlat.split(',')[0], e.lonlat.split(',')[1]], 17)
      this.searchList = []
    },
    inputChange() {
      // if(!this.queary){

      // }
    },
    changeType() {
      this.queary = ''
      this.lastCode = ''
      this.placeholder = ''
      this.address = ''
      if (this.mapType == '2') {
        this.mapObject.registClick(3)
        this.placeholder = '请输入地址'
        this.mapObject.removeInteractionForPolygon();
        this.mapObject.removeVectorLayer("drawPolygon");
        store.commit('mapMesChange', {})
      } else if (this.mapType == '3') {
        this.mapObject.registClick(3)
        this.placeholder = '请输入坐标'
        this.mapObject.removeInteractionForPolygon();
        this.mapObject.removeVectorLayer("drawPolygon");
        store.commit('mapMesChange', {})
      } else {
        this.mapObject.registClick(0)
        this.placeholder = '请输入地址'
      }
      store.commit('mapMesChange', {})

      this.$emit("change", this.mapType);
    }
  }
};
</script>
<style lang="less" scoped>
.inputSearch {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;

  .inputContent {
    display: flex;

    .seachbtn {
      width: 40px;
      height: 20px;
      background: red;
    }
  }

  .searchContent {
    height: 300px;
    background-color: #fff;
    overflow-y: scroll;

    .searchLi {
      padding: 2px 5px;
      border-bottom: solid 1px #eee;
      cursor: pointer;

      .contentLi {
        font-size: 14px;
        color: #1d1a1a;
      }
    }
  }
  /deep/.el-cascader{
    input{
      pointer-events: none;
    }
  }
}
</style>
